﻿import { BarChart3, Clock, TrendingUp } from "lucide-react";
import { useGrowthData } from "@/hooks/growth/useGrowthData";

export function RevenuePanel({
  data,
}: {
  data: ReturnType<typeof useGrowthData>;
}) {
  const { revenueMetrics } = data;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-3 bg-emerald-500/10 text-emerald-500 rounded-xl">
            <BarChart3 size={24} />
          </div>
          <div>
            <h2 className="text-xl font-bold text-slate-100">
              Projeção do Mês Atual
            </h2>
            <p className="text-sm text-slate-400">
              Baseado na média dos dias anteriores
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex justify-between items-center p-4 bg-slate-950 rounded-xl border border-slate-800">
            <span className="text-slate-400">
              Faturamento Realizado (Até hoje)
            </span>
            <span className="text-2xl font-bold text-white">
              R${" "}
              {revenueMetrics.currentTotal.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
              })}
            </span>
          </div>

          <div className="flex justify-between items-center p-4 bg-slate-800/50 rounded-xl border border-emerald-900/30">
            <span className="text-emerald-400 font-medium flex items-center gap-2">
              <TrendingUp size={18} />
              Previsão de Fechamento (Fim do Mês)
            </span>
            <span className="text-3xl font-extrabold text-emerald-400">
              R${" "}
              {revenueMetrics.predictedTotal.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
              })}
            </span>
          </div>

          <p className="text-xs text-slate-500 text-center">
            Média diária atual: R${" "}
            {revenueMetrics.avgPerDay.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
            /dia
          </p>
        </div>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 shadow-sm flex flex-col justify-center items-center text-center">
        <Clock className="text-purple-500 mb-4" size={48} opacity={0.8} />
        <h3 className="text-2xl font-bold text-slate-200 mb-2">
          Horários de Pico (Em Breve)
        </h3>
        <p className="text-slate-400 max-w-sm">
          O algoritmo está coletando mais dados da sua operação. Em breve você
          verá mapas de calor com os dias e horas que seu lava-jato mais enche.
        </p>
      </div>
    </div>
  );
}
